<div class="p-4 md:p-6 max-w-3xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">swap_horiz</mat-icon>
      Abonos / Débitos
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Registra transacciones de abono o débito en cuentas de trabajo.
    </p>
  </div>

  <!-- Card formulario -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="formCuenta">

    <!-- Header card -->
    <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">receipt_long</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f;">Datos de la transacción</span>
      </div>
    </div>

    <!-- Formulario -->
    <form (ngSubmit)="guardarBeneficiario()" [formGroup]="formCuenta" class="p-4 md:p-6">

      <!-- Checkbox interna -->
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 20px; padding: 10px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
        <mat-checkbox formControlName="interna" color="primary">
          <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">Transacción Interna</span>
        </mat-checkbox>
      </div>

      <!-- Grid campos -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1">

        <!-- Monto -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Monto</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">attach_money</mat-icon>
          <input type="number" matInput step="any" formControlName="monto" placeholder="Ingrese el monto">
          <mat-error *ngIf="formCuenta.get('monto')?.invalid && (formCuenta.get('monto')?.dirty || formCuenta.get('monto')?.touched)">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <!-- Precio compra -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Precio compra</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">sell</mat-icon>
          <input type="number" step="any" matInput formControlName="precioCompra" placeholder="Ingrese el valor">
        </mat-form-field>

        <!-- Tipo transacción -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Tipo de transacción</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">category</mat-icon>
          <mat-select required formControlName="tipoTransaccion">
            <mat-option>Seleccione uno</mat-option>
            <mat-option *ngFor="let tipo of tiposTransaccion" [value]="tipo">
              {{ tipo | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Tipo abono/débito -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Tipo de abono/débito</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">account_balance_wallet</mat-icon>
          <mat-select required formControlName="tipoAbonoDebito">
            <mat-option>Seleccione uno</mat-option>
            <mat-option *ngFor="let tipo of tipos" [value]="tipo">
              {{ tipo | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- País -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>País</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">public</mat-icon>
          <mat-select required formControlName="pais" (selectionChange)="getBanks()">
            <mat-option>Seleccione país</mat-option>
            <mat-option *ngFor="let pais of paisesActivos" [value]="pais.codigoPais">
              {{ pais.nombre | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Cuenta -->
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Cuenta</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
          <mat-select required formControlName="cuenta">
            <mat-option>Seleccione cuenta</mat-option>
            <mat-option *ngFor="let cuenta of cuentasTrabajo" [value]="cuenta.cuenta_trabajo_id">
              {{ cuenta.nombre | titlecase }} {{ cuenta.apellidos | titlecase }}
              {{ cuenta.banco?.nombre }} {{ cuenta.numeroCuenta }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Comentarios (full width) -->
        <div class="md:col-span-2">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Comentarios</mat-label>
            <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">comment</mat-icon>
            <input type="text" matInput formControlName="comentario" placeholder="Ingrese un comentario">
            <mat-error *ngIf="this.formCuenta.get('comentario')!.hasError('maxlength')">
              Máximo 120 caracteres
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Botón guardar -->
      <div class="flex justify-center mt-2">
        <button type="submit"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 40px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">save</mat-icon>
          Guardar
        </button>
      </div>
    </form>
  </div>

</div>
